import * as localizationKeys from '../../consts/localization/localizationKeys';
import NotificationModalTypes from '../../enums/app/notificationModalTypes';
import {setNotificationInfo, setNotificationSuccess} from '../../state/ducks/global';
import {makeSelectDeviceName, makeSelectHolderName} from '../../state/selectors/consumer';
import {selectIsMonoDevice} from '../../state/selectors/iotDevice';
import {dispatch, getState} from '../../state/store';
import elementsTesIds from '../../test/consts/elementsTesIds';
import {getLocalizedStrings} from '../localization/localizationService';

const showInsertHolderNotification = () =>
    dispatch(
        setNotificationInfo(getLocalizedStrings()[localizationKeys.USB_DEVICE_SETTINGS_INSERT_HOLDER_NOTIFICATION_TEXT])
    );

const showLockNotification = (isLocked) => {
    const state = getState();
    const isMonoDevice = selectIsMonoDevice(state);
    const nameSelector = isMonoDevice ? makeSelectDeviceName : makeSelectHolderName;
    const targetName = nameSelector()(state);
    const localizedStrings = getLocalizedStrings();
    const messageKey = isLocked
        ? localizationKeys.LOCK_HOLDER_SUCCESS_NOTIFICATION
        : localizationKeys.UNLOCK_HOLDER_SUCCESS_NOTIFICATION;
    const message = localizedStrings.formatString(localizedStrings[messageKey], targetName);
    const testId = isLocked
        ? elementsTesIds.DEVICE_SETTINGS_LOCK_SUCC_NOTIFIC
        : elementsTesIds.DEVICE_SETTINGS_UNLOCK_SUCC_NOTIFIC;

    dispatch(setNotificationSuccess(message, testId));
};

const showPromotedRegistrationNotification = () => {
    dispatch(
        setNotificationInfo(
            null,
            elementsTesIds.PROMOTED_REGISTRATION_NOTIFICATION,
            NotificationModalTypes.PROMOTED_REGISTRATION,
            true
        )
    );
};

export default {
    showInsertHolderNotification,
    showLockNotification,
    showPromotedRegistrationNotification,
};
